import newsData from './news.json';

// News lives in news.json (not here) because two runtimes read it: this
// module for the React app, and scripts/generate-news-pages.js, a plain
// Node script that bakes per-item Open Graph pages after the build.
export type NewsItem = {
  /** URL path segment: the item is shareable at /news/<slug>. */
  slug: string;
  /** Display date, e.g. "Jun 2026". */
  date: string;
  /** Machine-readable date for article:published_time meta. */
  isoDate: string;
  title: string;
  body: string;
  href?: string;
  linkLabel?: string;
};

export const NEWS: NewsItem[] = newsData;

export const newsPath = (slug: string) => `/news/${slug}`;
